import Vue from "vue";
import Router from "vue-router";

import login from "@/views/login.vue";
import registe from "@/views/registe.vue";
import userset from "@/views/userset.vue";
import hadoop from "@/views/hadoop.vue";

import mainD from "@/views/main/container.vue";
import main from "@/views/main/main.vue";
import location from "@/views/main/location.vue";
import statistics from "@/views/main/statistics.vue";
import scattergram from "@/views/main/terminalpath.vue";
import account from "@/views/main/account.vue";
import warning from "@/views/main/warning.vue";

import production from "@/views/production/container.vue";
import eat from "@/views/production/eat.vue";
import record from "@/views/production/record.vue";
import rfid from "@/views/production/rfid.vue";
import species from "@/views/production/species.vue";
import speciesP from "@/views/production/speciesP.vue";
import userT from "@/views/production/userT.vue";
import claim from "@/views/production/claim.vue";
import ramp from "@/views/production/ramp.vue";
import turnover from "@/views/production/turnover.vue";

import video from "@/views/video/container.vue";
import fullview from "@/views/video/fullView.vue";
import show from "@/views/video/show.vue";
import singlectr from "@/views/video/singleCtr.vue";
import Screenshot from "@/views/video/Screenshot.vue";

import iot from "@/views/Iot/container.vue";
import terminal from "@/views/Iot/iot/ZdInformation.vue";
import sensor from "@/views/Iot/iot/SensorData.vue";
import compare from "@/views/Iot/iot/sjtb.vue";
import current from "@/views/Iot/iot/ssqx.vue";
import history from "@/views/Iot/iot/history.vue";
import Aerationoperate from "@/views/Iot/iot/Aerationoperate.vue";
import monitor from "@/views/Iot/set/exceptionSet.vue";
import strategy from "@/views/Iot/set/PolicySet.vue";
import anomaly from "@/views/Iot/unusual/exceptionInformation.vue";
import RFIDData from "@/views/Iot/iot/RFIDData.vue";
import Packet from "@/views/Iot/iot/Packet.vue";
import PacketData from "@/views/Iot/iot/PacketData.vue";
import Disinfection from "@/views/Iot/iot/Disinfection.vue";
import Sample from "@/views/Iot/iot/Sample.vue";

import traceability from "@/views/traceability/container.vue";
import retrospect from "@/views/traceability/retrospect.vue";
import settle from "@/views/traceability/settle.vue";
import details from "@/views/traceability/details.vue";

import RL from "@/views/RL/container.vue";
import Claimrecord from "@/views/RL/Claimrecord.vue";
import Contract from "@/views/RL/Contract.vue";
import Fence from "@/views/RL/Fence.vue";
import Species from "@/views/RL/Species.vue";
import Speciesdetails from "@/views/RL/Speciesdetails.vue";

import test from "@/views/test.vue";

Vue.use(Router);

export default new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/test',
			name: 'test',
			component: test
		},
		{
			path: '/login',
			name: 'login',
			component: login
		},
		{
			path: '/registe',
			name: 'registe',
			component: registe
		},
		{
			path: '/details',
			name: 'details',
			component: details
		},
		{
			path: '/hadoop',
			name: 'hadoop',
			component: hadoop
		},
		{
			path: '/',
			name: 'mainD',
			component: mainD,
			redirect: '/main',
			children: [{
					path: "/main",
					name: "main",
					component: main
				},
				{
					path: "/location",
					name: "location",
					component: location
				},
				{
					path: "/statistics",
					name: "statistics",
					component: statistics
				},
				{
					path: 'scattergram',
					name: 'scattergram',
					component: scattergram
				},
				{
					path: 'account',
					name: 'account',
					component: account
				},
				{
					path: 'warning',
					name: 'warning',
					component: warning
				},
				{
					path: 'userset',
					name: 'userset1',
					component: userset
				}
			]
		},
		{
			path: "/production",
			name: "production",
			component: production,
			redirect: '/production/record',
			children: [
				{
					path: 'eat',
					name: 'eat',
					component: eat
				},
				{
					path: 'record',
					name: 'record',
					component: record
				},
				{
					path: 'rfid',
					name: 'rfid',
					component: rfid
				},
				{
					path: 'species',
					name: 'species',
					component: species
				},
				{
					path: 'speciesP',
					name: 'speciesP',
					component: speciesP
				},
				{
					path: 'userT',
					name: 'userT',
					component: userT
				},
				{
					path: 'claim',
					name: 'claim',
					component: claim
				},
				{
					path: 'ramp',
					name: 'ramp',
					component: ramp
				},
				{
					path: 'turnover',
					name: 'turnover',
					component: turnover
				},
				{
					path: 'userset',
					name: 'userset2',
					component: userset
				}
			]
		},
		{
			path: "/video",
			name: "video",
			component: video,
			redirect: '/video/show',
			children: [
				{
					path: 'show',
					name: 'show',
					component: show
				},
				{
					path: 'fullview',
					name: 'fullview',
					component: fullview
				},
				{
					path: 'singlectr',
					name: 'singlectr',
					component: singlectr
				},
				{
					path: 'Screenshot',
					name: 'Screenshot',
					component: Screenshot
				},
				{
					path: 'userset',
					name: 'userset3',
					component: userset
				}
			]
		},
		{
			path: "/iot",
			name: "iot",
			component: iot,
			redirect: '/iot/terminal',
			children: [
				{
					path: 'terminal',
					name: 'terminal',
					component: terminal
				},
				{
					path: 'sensor',
					name: 'sensor',
					component: sensor
				},
				{
					path: 'compare',
					name: 'compare',
					component: compare
				},
				{
					path: 'current',
					name: 'current',
					component: current
				},
				{
					path: 'history',
					name: 'history',
					component: history
				},
				{
					path: 'monitor',
					name: 'monitor',
					component: monitor
				},
				{
					path: 'strategy',
					name: 'strategy',
					component: strategy
				},
				{
					path: 'anomaly',
					name: 'anomaly',
					component: anomaly
				},
				{
					path: 'Aerationoperate',
					name: 'Aerationoperate',
					component: Aerationoperate
				},
				{
					path: 'RFIDData',
					name: 'RFIDData',
					component: RFIDData
				},
				{
					path: 'Packet',
					name: 'Packet',
					component: Packet
				},
				{
					path: 'PacketData',
					name: 'PacketData',
					component: PacketData
				},
				{
					path: 'Disinfection',
					name: 'Disinfection',
					component: Disinfection
				},
				{
					path: 'Sample',
					name: 'Sample',
					component: Sample
				},
				{
					path: 'userset',
					name: 'userset4',
					component: userset
				}
			]
		},
		{
			path: "/traceability",
			name: "traceability",
			component: traceability,
			redirect: '/traceability/retrospect',
			children: [
				{
					path: 'retrospect',
					name: 'retrospect',
					component: retrospect
				},
				{
					path: 'settle',
					name: 'settle',
					component: settle
				},
				{
					path: 'userset',
					name: 'userset5',
					component: userset
				}
			]
		},
		{
			path: '/RL',
			name: 'RL',
			component: RL,
			redirect: '/RL/Claimrecord',
			children: [
				{
					path: "Claimrecord",
					name: "Claimrecord",
					component: Claimrecord
				},
				{
					path: "Contract",
					name: "Contract",
					component: Contract
				},
				{
					path: "Fence",
					name: "Fence",
					component: Fence
				},
				{
					path: 'Species',
					name: 'Species',
					component: Species
				},
				{
					path: 'Speciesdetails',
					name: 'Speciesdetails',
					component: Speciesdetails
				},
				{
					path: 'userset',
					name: 'userset6',
					component: userset
				}
			]
		}
	]
});
